import { rootUrl } from "./global"

export const getJwtToken = (email, password) => rootUrl.post('/auth/login?version=v1', { email, password })

export const stateList = () => rootUrl.get('/list/state?version=v1')

export const loantypList = () => rootUrl.get('/list/loantyp?version=v1')

export const desigList = () => rootUrl.get('/list/desig?version=v1')

export const securitytypList = () => rootUrl.get('/list/securitytyp?version=v1')

export const statusList = () => rootUrl.get('/list/status?version=v1')

export const activitytypList = () => rootUrl.get('/list/activitytyp?version=v1')

export const deleteAccountData = (type, id) => rootUrl.get(`/account/${type}/${id}?version=v1`)

export const createAccount = (accountDetails) => rootUrl.post(`/account?version=v1`, accountDetails)

export const getAccountDataByID = (id) => rootUrl.get(`/account/${id}?version=v1`)

export const deleteAccountDataByID = (id) => rootUrl.delete(`/account/${id}?version=v1`)

export const deleteSarfaesiDataByID = (id) => rootUrl.delete(`/account/${id}?version=v1`)

export const deletePaymentByID = (id) => rootUrl.delete(`/payment/${id}?version=v1`)

export const viewAccount = () => rootUrl.get('/account?version=v1')

export const viewAccountSubmittedBy = () => rootUrl.get('/account/submittedby?version=v1')

export const createBank = (bankDetails) => rootUrl.post(`/bank?version=v1`, bankDetails)

export const uploadFile = (filedata) => rootUrl.post(`/cloud/upload?version=v1`, filedata)

export const showBank = () => rootUrl.get('/bank?version=v1')

export const showPayments = () => rootUrl.get('/payment?version=v1')

export const showPaymentByAccountID = (id) => rootUrl.get(`/payment/account/${id}?version=v1`)

export const createPayment = (payment) => rootUrl.post('/payment?version=v1', payment)

export const showBankPayment = () => rootUrl.get('/payment/bybank?version=v1')

export const showAccountByBankID = (id) => rootUrl.get(`/payment/byaccount/${id}?version=v1`)

export const getBankDataByID = (id) => rootUrl.get(`/bank/${id}?version=v1`)

export const viewDashboardEvents = (startDate, endDate) => rootUrl.get(`/dashboard/events?version=v1&startDate=${startDate}&endDate=${endDate}`)

export const viewDashboard = () => rootUrl.get('/dashboard/summary?version=v1')

export const showProjects = () => rootUrl.get('/project/all?version=v1')

export const updateProject = (project) => rootUrl.put(`/project?version=v1`, project)

export const createProject = (projectData) => rootUrl.post(`/project?version=v1`, projectData)

export const showUsers = () => rootUrl.get('/user?version=v1')

export const updateUser = (user) => rootUrl.put(`/user?version=v1`, user)

export const createUser = (userData) => rootUrl.post(`/user?version=v1`, userData)

export const deleteBankDataByID = (id) => rootUrl.delete(`/bank/${id}?version=v1`)

export const showDistinctBank = () => rootUrl.get(`/bank/name?version=v1`)

export const getMortgagePropertyByAccount = (id) => rootUrl.get(`/account/mortgageproperty/${id}?version=v1`)

export const showImage = (fileName) => {
    return rootUrl.get(`/cloud/download?version=v1&keyName=${fileName}`, {
        responseType: 'arraybuffer',
    });
};

export const bankProgressReport = (bankName, bankState, bankCity) =>
    rootUrl.get(`/report/bankwise?version=v1&bankName=${bankName}&bankState=${bankState}&bankCity=${bankCity}`, {
        responseType: 'arraybuffer', 
});

